
import AppButton from "./AppButton"

export default {
  components: {
    AppButton
  },
  props: {
    variant: {
      type: String,
      validator: val =>
        ["generic", "notFoundError", "networkError"].includes(val),
      required: true
    },
    button: {
      type: Object,
      default: null
    }
  },
  computed: {
    layoutSettings() {
      return this.layoutConfigMap[this.variant]
    },
    layoutConfigMap() {
      return {
        generic: {
          header: "An error occurred"
        },
        notFoundError: {
          header: "The page you were looking for doesn’t exist.",
          copy: "You may have mistyped the address or the page may have moved."
        },
        networkError: {
          header: "Uh oh, looks like there’s no internet!",
          copy: "Please check your connection and try again."
        }
      }
    }
  }
}
